// import Port from './Port';
// const globalIP = (() => {
//   const { hostname } = window.location; // Get the current hostname
//   const port = Port.globelport; // Define your backend port
//   // const primaryIP = `http://${hostname}${port}`; // Construct the primary IP
//   // const primaryIP = `https://api.artistaerp.cloud`; // Construct the primary IP
//   const primaryIP = `http://192.168.1.46${port}`; // Construct the primary IP
//   return primaryIP; // Return only the primary IP
// })();

// export default globalIP;

import Port from './Port';

const globalIP = (() => {
  const { hostname } = window.location;
  const port = Port.globelport;

  let primaryIP;

  // ✅ Check if hostname includes '192.'
  if (hostname.includes('192.') || hostname.includes('localhost')) {
    // primaryIP = `http://${hostname}${port}`; // Local system IP
    // primaryIP = `http://192.168.1.19${port}`; // Construct the primary IP
    // primaryIP = `http://192.168.5.119${port}`; // Construct the primary IP
    // primaryIP = `http://110.227.189.169${port}`; // Construct the primary IP
      primaryIP = `https://designupapi.growwizo.com`;
      // primaryIP = `https://growwizoapi.sabrass.cloud`;
      // primaryIP = `https://ug.sharmaonline.in`;
      // primaryIP = `https://api.artistaerp.cloud`;
  } else {
    // primaryIP = `https://growwizoapi.sabrass.cloud`; // Live server URL
    primaryIP = `https://designupapi.growwizo.com`;
  }

  return primaryIP;
})();
export const IS_USE_ALIAS = false; // change true/false anytime

export default globalIP;

// const globalIP = (() => {
//   const { hostname } = window.location; // Get the current hostname
//   const port = '1338'; // Define your backend port
//   const primaryIP = `http://${hostname}:${port}`; // Construct the primary IP
//   const fallbackIP = `http://192.168.1.46:1338`; // Define the fallback IP
//http://103.207.64.237:1331/
//   try {
//     // Use a synchronous XMLHttpRequest to check the primary IP
//     const xhr = new XMLHttpRequest();
//     xhr.open('GET', `${primaryIP}/api/user-details`, false); // `false` makes the request synchronous
//     xhr.send(null);

//     if (xhr.status >= 200 && xhr.status < 300) {
//       console.log(`Primary IP is working: ${primaryIP}`);
//       return primaryIP;
//     } else {
//       throw new Error('API response not OK');
//     }
//   } catch (error) {
//     console.error(`Primary IP failed, switching to fallback IP: ${fallbackIP}`, error);
//     return fallbackIP;
//   }
// })();

// export default globalIP;
